const Footer = () => {
    return ( 
        <div className="Footer  ">
            <p className=" text-center text-white bg-dark p-2">&copy; Ajibade Emmanuel</p>
        </div>
    );
    //  );Revoluntionary principle, text pawn send blessing adesiji gmail to add you to the community, joy ollie, G_makunde,text or fill adora google form, text azyzag adekunle and be friends with her if you can exchange opportunities,  text iconicshotsNdev if his company needs a FE, message foundational black designer and try to be friends if she can share you some of the frontend intenships
}
 
export default Footer;